<template>
  <div class="row">
    <div class="bold-label">
      <app-form-field id="expireDateLabel" :title="'Aanbod geldig tot'" :error-message="''" />
    </div>
    <div class="datepicker-container">
      <date-picker
        id="expireDate"
        :min-date="minDate"
        :date="expireDate"
        title=""
        :error-message="errorMessageExpireDate"
        :disabled="disabled"
        @change-date="changeExpireDate"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import DatePicker from '@/components/generic/presentational/atoms/datePicker/DatePicker.vue'
import { mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { EventBus } from '@/plugins/event-bus'
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'

export default {
  components: {
    DatePicker,
    AppFormField,
  },
  mixins: [AdditionalOrder],
  validations() {
    const isAfterMinDate = (value) => {
      return value != 'INVALID' && value.isSameOrAfter(this.minDate, 'day')
    }

    const isValidDate = (value) => {
      return moment.utc(value).isValid()
    }

    return {
      expireDate: {
        required,
        isAfterMinDate,
        isValidDate,
      },
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      minDate: moment(),
      expireDate: null,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      quoteId: 'quote/quoteId',
    }),
    dateIsStrangeInfoText() {
      return 'De gekozen niet leveren voor datum verschilt meer dan 6 maanden met de actuele leverdatum is dit correct?'
    },
    errorMessageExpireDate() {
      if (this.v$.expireDate.$anyDirty) {
        if (!this.v$.expireDate.required.$response) return 'Geldigsheiddatum tot is verplicht'
        if (!this.v$.expireDate.isValidDate.$response)
          return 'Vul een geldige geldigsheiddatum in (dd-mm-jjjj)'
        if (!this.v$.expireDate.isAfterMinDate.$response)
          return 'De geldigsheiddatum moet vanaf vandaag zijn'
      }
      return ''
    },
  },
  created() {
    this.expireDateUpdate()
  },
  mounted() {
    EventBus.$on('quote/expireDate', this.expireDateUpdate)
  },
  unmounted() {
    EventBus.$off('quote/expireDate', this.expireDateUpdate)
  },
  methods: {
    changeExpireDate(value) {
      this.expireDate = value
      this.v$.expireDate.$touch()
      if (!this.v$.expireDate.$error) {
        this.$store.dispatch(
          `${this.quoteNamespace}/setExpireDate`,
          value.toJSON().slice(0, 19) // format to yyyy-MM-ddTHH:mm:ss
        )
      }
    },
    expireDateUpdate() {
      const stateExpireDate = this.$store.getters[`${this.quoteNamespace}/expireDate`]
      this.expireDate = stateExpireDate ? moment.utc(stateExpireDate) : null
    },
  },
}
</script>

<style lang="scss" scoped>
.datepicker-container {
  min-height: 52px;
}

.bold-label {
  font-weight: $font-weight-bold;
}
</style>
